import { Component, OnInit, NgModule } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule } from '@angular/forms';
import { CrudService } from '../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { createAutoCorrectedDatePipe } from 'text-mask-addons';

import { Mensaje } from '../../../mensaje';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';

import * as jQuery from 'jquery';
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable';
import * as moment from 'moment';


@Component({
  selector: 'app-ver',
  templateUrl: './ver.component.html',
  styles: ['.card { margin-bottom: 12px; }']
})

export class VerComponent implements OnInit{
  dato: FormGroup;
  datos_grupos: any[] = [{ 'carreras': ['nombre'] }];

  icon; id; card;

  tab = 1;
  tab2 = 1;

  tamano = document.body.clientHeight;

  documentos = [];
  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  logo_sucursal = "";
  logo_empresa = "";

  grupos = [];
  tieneid;
  form_personas_rfcs;
  esSemestral = false;
  cargarDatosCatalogo = true;

  carrera_id: number = null;
  descripcion_beca: any = '';
  inscripcion: number = 0;
  reinscripcion: number = 0;
  colegiatura: number = 0;
  beca_inscripcion: number = 0;
  beca_reinscripcion: number = 0;
  beca_colegiatura: number = 0;
  texto_inscripcion = ' ';
  texto_reinscripcion = ' ';
  texto_colegiatura = ' ';

  grupo_selecionado = {
    carrera: '',
    plan: '',
    modalidad: '',
    turno: '',
    tipo_periodo: '',
    nivel: '',
    periodo_escolar: '',
    fecha_inicio: ''
  };
  beca_texto = '';
  plan_seleccionado = [];
  beca_seleccionado = {
    id: '',
    nombre: '',
    es_porcentaje: 0,
    becas_detalles_articulos: [
      { 'db61c2cb92dde2df6e62b4b0744f9dce': { importe: 0, total: 0 } },
      { '83dae74b6269ce625f4babc3fa613be2': { importe: 0, total: 0 } },
      { '12a00afca32cafa9f493f73f2b7f8bcf': { importe: 0, total: 0 } },
      { '549ff7cf2b0d4d82ca99ca7999263207': { importe: 0, total: 0 } }
    ]
  };

  // Crear la variable que mustra las notificaciones
  mensajeResponse: Mensaje = new Mensaje()

  titulo = 'Alumnos';

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private crud: CrudService, private notificacion: NotificationsService) { }

  ngOnInit() {
    for (let c = 0; c < 12; c++) {
      this.acordeon[c] = false;
    }
    this.dato = this.fb.group({
      id: [''],
      tipos_personas_id: [1],

      nombre: ['', [Validators.required]],
      apellido_paterno: ['', [Validators.required]],
      apellido_materno: ['', [Validators.required]],
      curp: ['', [Validators.required]],
      sexo: ['F', [Validators.required]],

      proceso_revalidacion: [0],
      revalidaciones_id: [null],
      matricula: [''],
      planes_pagos_id: ['', [Validators.required]],
      becas_id: [''],
      email: [''],
      username: [''],
      alumnos_inicializacion: this.fb.group({
        nivel: [1],
        mes: [0],
        inicializado: [0],
        completado: [0],
        ultimo_abono: ['']
      }),
      referencia_bancaria: [''],
      referencia_bancaria_automatica: [0],
      documentos_validados: [0],
      personas_metadatos: this.fb.group({
        carreras_planes_id: [''],
        periodos_escolares_id: [''],
        grupos_id: ['']
      }),
      personas_rfcs: this.fb.array([]),
    });

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });

    this.form_personas_rfcs = {
      tipo_persona: ['Fisica', [Validators.required]],
      tipos_regimenes_fiscales_id: [''],
      rfc: ['', [Validators.required]],
      razon_social: ['', [Validators.required]],
      paises_id: [1],
      estados_id: [7],
      municipios_id: [180],
      localidad: [''],
      colonia: [''],
      calle: [''],
      numero_exterior: [''],
      numero_interior: [''],
      codigo_postal: [''],
      email: ['', [Validators.required]],
      predeterminado: [0]
    };
    this.formulario['alumno'] = {
      formularios_secciones: []
    };
    this.obtenerFormularios("alumno");
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  /**
     * Este método selecciona un valor de un select2 y lo pasa al modelo
     * @param valor valor del options del selec seleccionado
     * @param modelo  modelo donde se agrega el valor
     * @return void
     */
  carrera_plan(valor: any, modelo, url: string = '', item) {
    this.cargarDatosCatalogo = true;
    if (url != '') {
      this.crud.lista(this.parametros, url + '?carreras_planes_id=' + this.dato.controls.personas_metadatos['controls']['carreras_planes_id'].value + '&periodos_escolares_id=' + this.dato.controls.personas_metadatos['controls']['periodos_escolares_id'].value).subscribe(
        resultado => {
          resultado.data.forEach(element => {
            if (!element.text)
              element.text = element.nombre;
          });
          this.grupos = resultado.data;
          this.grupos.forEach(element => {
            if (this.dato.controls.personas_metadatos.get('grupos_id').value == element.id) {

              this.grupo_selecionado = {
                carrera: element.carreras_planes.carreras.nombre,
                plan: element.carreras_planes.planes_estudios.nombre,
                modalidad: element.periodos_escolares.modalidades.nombre,
                turno: element.turnos.nombre,
                tipo_periodo: element.periodos_escolares.tipos_periodos.nombre,
                nivel: element.nivel,
                periodo_escolar: element.periodos_escolares.nombre,
                fecha_inicio: element.periodos_escolares.fecha_inicio
              };
            }
          });
          this.cargarDatosCatalogo = false;
        },
        error => {
          this.cargarDatosCatalogo = false;
        }
      );
    }
  }

  /**
    * Este método selecciona un valor de un select2 y lo pasa al modelo
    * @param valor valor del options del selec seleccionado
    * @param modelo  modelo donde se agrega el valor
    * @return void
    */
  grupo(valor: any, item, planes: any[] = []) {
    let nivel = 1;
    this.grupos.forEach(element => {
      if (item == element.id) {

        this.grupo_selecionado = {
          carrera: element.carreras_planes.carreras.nombre,
          plan: element.carreras_planes.planes_estudios.nombre,
          modalidad: element.periodos_escolares.modalidades.nombre,
          turno: element.turnos.nombre,
          tipo_periodo: element.periodos_escolares.tipos_periodos.nombre,
          nivel: element.nivel,
          periodo_escolar: element.periodos_escolares.nombre,
          fecha_inicio: element.periodos_escolares.fecha_inicio
        };

        nivel = element.nivel;
        this.esSemestral = false;
        if (element.carreras_planes.carreras.tipos_periodos.duracion_meses == 6)
          this.esSemestral = true;
      }
    });

    if (planes.length > 0) {
      planes[0].planes_pagos_detalles.forEach(element => {
        if (this.carrera_id == element.carreras_id) {
          element.articulos.forEach(elementt => {
            if (elementt.articulos.sku == 0 && (elementt.nivel == nivel || elementt.nivel == 0))
              this.inscripcion = elementt.importe; //Inscripcion
            if (elementt.articulos.sku == 1 && (elementt.nivel == nivel || elementt.nivel == 0))
              this.reinscripcion = elementt.importe; //Reinscripcion
            if (elementt.articulos.sku == 2 && (elementt.nivel == nivel || elementt.nivel == 0))
              this.colegiatura = elementt.importe; //Colegiatura
          });
        }
      });
      if (this.dato.controls.becas_id.value == '' || this.dato.controls.becas_id.value == null) {
        this.descripcion_beca = '';
        this.texto_colegiatura, this.texto_inscripcion, this.texto_reinscripcion = ' ';
        this.beca_inscripcion = 0, this.beca_reinscripcion = 0, this.beca_colegiatura = 0;
      }
      if (this.dato.controls.personas_metadatos.get('carreras_planes_id').value == '') {
        this.inscripcion = 0; this.reinscripcion = 0; this.colegiatura = 0;
      }
    } else {
      this.mensajeResponse.titulo = 'Plan de pago';
      this.mensajeResponse.texto = `No se encontró plan de pago activo, Verifique.`;
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.clase = 'info';
      this.mensaje(3);
    }
  }

  /**
   * Este método selecciona un valor de un select2 y lo pasa al modelo
   * @param valor valor del options del selec seleccionado
   * @param modelo  modelo donde se agrega el valor
   * @return void
   */
  plan(valor: any, modelo, carreras_planes: any[] = [], planes: any[] = []) {

    if (planes.length > 0) {
      this.dato.controls.planes_pagos_id.setValue(planes[0].id); // id del plan de pago
      //let carrera_id:number = null;
      this.inscripcion = 0; this.reinscripcion = 0; this.colegiatura = 0;

      carreras_planes.forEach(element => {
        if (this.dato.controls.personas_metadatos.get('carreras_planes_id').value == element.id) {
          this.carrera_id = element.carreras_id;
        }
      });

      let nivel = 1;
      this.grupos.forEach(element => {
        if (this.dato.controls.personas_metadatos.get('grupos_id').value == element.id) {
          this.grupo_selecionado = {
            carrera: element.carreras_planes.carreras.nombre,
            plan: element.carreras_planes.planes_estudios.nombre,
            modalidad: element.periodos_escolares.modalidades.nombre,
            turno: element.turnos.nombre,
            tipo_periodo: element.periodos_escolares.tipos_periodos.nombre,
            nivel: element.nivel,
            periodo_escolar: element.periodos_escolares.nombre,
            fecha_inicio: element.periodos_escolares.fecha_inicio
          };
          nivel = element.nivel;
          this.esSemestral = false;
          if (element.carreras_planes.carreras.tipos_periodos.duracion_meses == 6)
            this.esSemestral = true;
        }
      });

      planes[0].planes_pagos_detalles.forEach(element => {
        if (this.carrera_id == element.carreras_id) {
          element.articulos.forEach(elementt => {
            if (elementt.articulos.sku == 0 && (elementt.nivel == nivel || elementt.nivel == 0))
              this.inscripcion = elementt.importe; //Inscripcion
            if (elementt.articulos.sku == 1 && (elementt.nivel == nivel || elementt.nivel == 0))
              this.reinscripcion = elementt.importe; //Reinscripcion
            if (elementt.articulos.sku == 2 && (elementt.nivel == nivel || elementt.nivel == 0))
              this.colegiatura = elementt.importe; //Colegiatura
          });
        }
      });
      if (this.dato.controls.becas_id.value == '' || this.dato.controls.becas_id.value == null) {
        this.descripcion_beca = '';
        this.texto_colegiatura, this.texto_inscripcion, this.texto_reinscripcion = ' ';
        this.beca_inscripcion = 0, this.beca_reinscripcion = 0, this.beca_colegiatura = 0;
      }
      if (this.dato.controls.personas_metadatos.get('carreras_planes_id').value == '') {
        this.inscripcion = 0; this.reinscripcion = 0; this.colegiatura = 0;
      }
    } else {
      this.mensajeResponse.titulo = 'Plan de pago';
      this.mensajeResponse.texto = `No se encontró plan de pago activo, Verifique.`;
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.clase = 'info';
      this.mensaje(3);
    }
  }

  /**
   * Este método selecciona un valor de un select2 y lo pasa al modelo
   * @param valor valor del options del selec seleccionado
   * @param modelo  modelo donde se agrega el valor
   * @return void
   */
  beca(valor: any, modelo, carreras_planes: any[] = [], becas: any[] = []) {

    this.descripcion_beca = '';
    this.beca_inscripcion = 0; this.beca_reinscripcion = 0; this.beca_colegiatura = 0;
    becas.forEach(element => {
      element.becas_detalles.forEach(elemento => {
        if (this.carrera_id == elemento.carreras_id && this.dato.controls.becas_id.value == element.id) {
          this.descripcion_beca = element.nombre + ': ' + element.descripcion;
          if (element.es_porcentaje == 1) {
            if (elemento.articulo.sku == 0) {
              this.texto_inscripcion = ' ( ' + elemento.importe + ' % ) ';
              this.beca_inscripcion = (this.inscripcion / 100) * elemento.importe;
            } //Inscripcion
            if (elemento.articulo.sku == 1) {
              this.texto_reinscripcion = ' (' + elemento.importe + ' % ) ';
              this.beca_reinscripcion = (this.reinscripcion / 100) * elemento.importe;
            } //Reinscripcion
            if (elemento.articulo.sku == 2) {
              this.texto_colegiatura = ' ( ' + elemento.importe + ' % ) ';
              this.beca_colegiatura = (this.colegiatura / 100) * elemento.importe;
            } //Colegiatura
          } else {
            if (elemento.articulo.sku == 0) {
              this.texto_inscripcion = ' ';
              this.beca_inscripcion = elemento.importe;
            } //Inscripcion
            if (elemento.articulo.sku == 1) {
              this.texto_reinscripcion = ' ';
              this.beca_reinscripcion = elemento.importe;
            } //Reinscripcion
            if (elemento.articulo.sku == 2) {
              this.texto_colegiatura = ' ';
              this.beca_colegiatura = elemento.importe;
            } //Colegiatura
          }
        }
      });
    });

    if (this.dato.controls.becas_id.value == '' || this.dato.controls.becas_id.value == null) {
      this.descripcion_beca = '';
      this.texto_colegiatura, this.texto_inscripcion, this.texto_reinscripcion = ' ';
      this.beca_inscripcion = 0, this.beca_reinscripcion = 0, this.beca_colegiatura = 0;
    }
    if (this.dato.controls.personas_metadatos.get('carreras_planes_id').value == '') {
      this.inscripcion = 0; this.reinscripcion = 0; this.colegiatura = 0;
    }
  }

  predeterminado(modelo) {
    this.dato.controls.personas_rfcs['controls'].forEach(element => {
      element.controls.predeterminado.patchValue(0);
    });

    modelo.patchValue(1);
  }

  // mostrar notificaciones configuracion default, posicion abajo izquierda, tiempo 2 segundos
  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };

  /**
   * Este método muestra los mensajes resultantes de los llamados de la api
   * @param cuentaAtras numero de segundo a esperar para que el mensaje desaparezca solo
   * @param posicion  array de posicion [vertical, horizontal]
   * @return void
   */
  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.titulo == '')
      this.mensajeResponse.titulo = this.titulo;

    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }
  // formularios dinamicos
  cargando = false;
  formulario = [];
  acordeon = [];
  catalogosDinamicos = [];
  formularioConstruido = false;
  obtenerFormularios(id) {
    this.cargando = true;
    this.crud.ver(id, "formulario").subscribe(
      resultado => {
        if (resultado.status == 200) {
          this.formulario[id] = resultado.data;
          for (let c = 0; c < this.formulario[id].formularios_secciones.length; c++) {
            this.acordeon[c] = false;
          }
          this.formulario[id].formularios_secciones.forEach(form => {

            form.formularios_secciones_campos.forEach(column => {
              column.forEach(campo => {
                if (campo) {
                  this.dato.controls.personas_metadatos["controls"][campo.campo] = new FormControl('');
                  if (campo.requerido) {
                    this.dato.controls.personas_metadatos["controls"][campo.campo].setValidators([Validators.required]);
                  }

                  if (campo.es_catalogo) {
                    if (campo.formularios_secciones_campos_catalogos) {
                      if (campo.formularios_secciones_campos_catalogos.es_api) {
                        this.obtenerCatalogosDinamicos(campo.formularios_secciones_campos_catalogos.datos, campo.campo)
                      }
                      else {
                        this.catalogosDinamicos[campo.campo] = JSON.parse(campo.formularios_secciones_campos_catalogos.datos);
                      }
                    }
                  }
                  if (campo.es_dependiente) {
                    if (campo.campo_dependiente.formularios_secciones_campos_catalogos.es_api) {
                      this.obtenerCatalogosDinamicos(campo.campo_dependiente.formularios_secciones_campos_catalogos.datos, campo.campo_dependiente.campo)
                    }
                    else {
                      this.catalogosDinamicos[campo.campo_dependiente.campo] = JSON.parse(campo.campo_dependiente.formularios_secciones_campos_catalogos.datos);
                    }
                  }
                }
              });
            });
          });
          this.formularioConstruido = true;
          document.getElementById("cargar_datos_dinamicos").click();
        } else {
          this.mensajeResponse.titulo = "Documentos";
          this.mensajeResponse.texto = "No configurado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Documentos";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  parametros = {
    pagina: 0,
    limite: 0
  };
  obtenerCatalogosDinamicos(url, id) {
    this.crud.lista(this.parametros, url).subscribe(
      resultado => {
        resultado.data.forEach(element => {
          if (!element.text) {
            element.text = element.nombre;
          }
        });
        this.catalogosDinamicos[id] = resultado.data;
      },
      error => {
      }
    );
  }
  
  obtenerCatalogosDependientesDinamicos(item, id) {
    let operador = "?";
    if (item.formularios_secciones_campos_catalogos.datos.indexOf("?") > -1)
      operador = "&";
    if (item.formularios_secciones_campos_catalogos.es_api) {
      this.catalogosDinamicos[item.campo] = [];
      this.crud.lista(this.parametros, item.formularios_secciones_campos_catalogos.datos + operador + "id=" + id).subscribe(
        resultado => {
          resultado.data.forEach(element => {
            if (!element.text) {
              element.text = element.nombre;
            }
          });
          this.catalogosDinamicos[item.campo] = resultado.data;
        },
        error => {
        }
      );
    } else {

    }
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }

  imprimir_ficha() {
    this.cargando = true;
    setTimeout(() => {
      let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

      moment.locale("es");
      let fecha = " FECHA: " + moment(new Date()).format("DD/MM/YYYY");

      let doc = new jsPDF("p", "mm", "letter");

      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 20, 18, "", "FAST");
      //Nombre empresa
      doc.setFontSize(15);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre, 108, 12, {align: "center"});

      doc.setFontSize(14);
      doc.setFont("helvetica", "", "bold");
      doc.text(this.configuracion.empresa.subnombre, 108, 18, {align: "center"});

      doc.setFontSize(12);
      doc.setFont("helvetica", "", "normal");
      doc.text("SOLICITUD DE INSCRIPCIÓN", 108, 24, {align: "center"});

      doc.text(this.configuracion.nivel_educativo.nombre.toUpperCase(), 108, 30, {align: "center"});


      doc.setFontSize(10);
      doc.text(fecha, 200, 40, {align: "right"});

      let conteo_lienas = 40;
      let foto = typeof this.dato.controls.personas_metadatos["controls"].foto != 'undefined' ? this.dato.controls.personas_metadatos["controls"].foto.value : ''
      if (foto != "" && foto)
        doc.addImage(foto, "PNG", 11, 47, 26, 32, "", "FAST");

      doc.rect(10, 46, 28, 34);

      // dinamico
      doc.setFontSize(9);
      let columna = 43;
      let columna_c = 43;
      let tm = 0;
      let documentos = null;
      this.formulario['alumno'].formularios_secciones.forEach((form, i) => {
        if (i > 0) {
          columna = 10;
          columna_c = 10;
          tm = 240;
        } else {
          tm = 150;
        }
        if (form.nombre == 'DOCUMENTOS') documentos = form;
        if (form.imprimir_en_comprobante && form.nombre != 'DOCUMENTOS') {
          doc.setFontSize(10);
          doc.setFont("helvetica", "", "bold");
          doc.text(form.nombre.toUpperCase(), 108, conteo_lienas, {align: "center"});
          conteo_lienas += 7;
          doc.setFontSize(7);
          doc.setFont("helvetica", "", "normal");
          form.formularios_secciones_campos.forEach((column, b) => {
            let tamanio_column = column.length;
            let clase3 = 0;
            column.forEach((campo, c) => {
              if (campo.imprimir_en_comprobante) {
                let clase = campo.clase.replace(/^\D+/g, '');
                if (clase == 3) {
                  clase = 6;
                  clase3++;
                  if (clase3 == 3) {
                    clase3 = 0;
                    conteo_lienas += 6;
                    columna = columna_c;
                  }
                }
                if (c > 0)
                  columna = columna + ((tm * clase) / 12);
                doc.text(campo.descripcion.toUpperCase() + ":", columna, conteo_lienas, {align: "left"});

                let nexclase = 0;
                if ((c + 1) < column.length) nexclase = column[c + 1].clase.replace(/^\D+/g, '');
                else nexclase = 12;

                let tc = campo.descripcion.replace(/ /g, '');
                let minus = 0;
                if (i == 0) {
                  minus = tc.length < 8 ? 18 : c == 1 && b == 0 ? 15 : 30;
                }

                let mas_col = ((200 * nexclase) / 12);
                let inicio = columna + tc.length * 1.9;
                let fin = columna + mas_col - minus;

                if (fin > 206)
                  fin = 206;

                doc.setFontSize(6);
                doc.setFont("helvetica", "italic", "");
                let info = this.dato.controls.personas_metadatos["controls"][campo.campo].value;
                if (campo.es_catalogo) {
                  if (info) {
                    this.catalogosDinamicos[campo.campo].forEach(cat => {
                      if (cat.id == info)
                        info = cat.nombre ? cat.nombre : cat.text;
                    });
                  }
                }
                if (!info) info = '';
                doc.text(info, inicio + 3, conteo_lienas, {align: "left"});
                doc.line(inicio, conteo_lienas + 1, fin, conteo_lienas + 1);
              }
              else if (campo.clase == 'is-12') {
                conteo_lienas = conteo_lienas - 7;
              }
            });
            columna = columna_c;
            conteo_lienas += 6;
          });
          conteo_lienas += 5;
        }
      });
      // fin dinamico
      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.text("DATOS ACADÉMICOS", 108, conteo_lienas, {align: "center"});
      conteo_lienas += 9;

      doc.setFontSize(7);
      doc.setFont("helvetica", "", "normal");
      doc.text("CARRERA:", 10, conteo_lienas, {align: "left"});
      doc.text("MODALIDAD:", 78, conteo_lienas, {align: "left"});
      doc.text("TURNO:", 146, conteo_lienas, {align: "left"});

      doc.setFontSize(6);
      doc.setFont("helvetica", "italic", "");
      doc.text(this.grupo_selecionado.carrera + "-" + this.grupo_selecionado.plan, 26, conteo_lienas, {align: "left"});
      doc.line(24, conteo_lienas + 1, 74, conteo_lienas + 1);

      doc.text(this.grupo_selecionado.modalidad, 98, conteo_lienas, {align: "left"});
      doc.line(95, conteo_lienas + 1, 140, conteo_lienas + 1);

      doc.text(this.grupo_selecionado.turno, 158, conteo_lienas, {align: "left"});
      doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

      conteo_lienas += 5;

      doc.setFontSize(7);
      doc.setFont("helvetica", "", "normal");
      doc.text(this.grupo_selecionado.tipo_periodo + ":", 10, conteo_lienas, {align: "left"});
      doc.text("CICLO ESCOLAR:", 53, conteo_lienas, {align: "left"});
      doc.text("INICIO DE CLASES:", 146, conteo_lienas, {align: "left"});

      doc.setFontSize(6);
      doc.setFont("helvetica", "italic", "");
      doc.text(this.grupo_selecionado.nivel + "", 36, conteo_lienas, {align: "left"});
      doc.line(34, conteo_lienas + 1, 48, conteo_lienas + 1);

      doc.text(this.grupo_selecionado.periodo_escolar, 78, conteo_lienas, {align: "left"});
      doc.line(76, conteo_lienas + 1, 140, conteo_lienas + 1);

      doc.text(this.grupo_selecionado.fecha_inicio, 173, conteo_lienas, {align: "left"});
      doc.line(170, conteo_lienas + 1, 206, conteo_lienas + 1);

      conteo_lienas += 6;

      let elem = document.getElementById("beca");
      let res = (doc as any).autoTableHtmlToJson(elem);
      (doc as any).autoTable(res.columns, res.data, {
        createdHeaderCell: function (cell, data) {
          cell.styles.halign = "left";
        },
        tableWidth: 187,
        startY: conteo_lienas,
        styles: {
          fontSize: 7,
        },
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 85 }
        }
      });

      conteo_lienas += 30;

      doc.line(5, 260, 107.4, 260);
      doc.line(5, 272, 210, 272);

      doc.line(5, 260, 5, 272);
      doc.line(103, 272, 108, 258);

      doc.line(107.8, 258, 210, 258);
      doc.line(210, 258, 210, 272);

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.text("CAMPUS " + this.configuracion.sucursal.nombre, 10, 265, {align: "left"});

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "normal");
      doc.text(this.configuracion.sucursal.direccion + " " + "Tels:" + this.configuracion.sucursal.telefono, 10, 268, {align: "left"});

      doc.setFontSize(9);
      doc.setFont("helvetica", "", "normal");
      doc.text(this.configuracion.sucursal.sitio + " / " + this.configuracion.sucursal.correo, 108, 267, {align: "left"});

      doc.addPage();
      conteo_lienas = 12;
      let form = documentos;
      if (form && form.imprimir_en_comprobante) {
        doc.setFontSize(12);
        doc.setFont("helvetica", "", "bold");
        doc.text(form.nombre, 108, conteo_lienas, {align: "center"});
        conteo_lienas += 5;
        doc.setFontSize(7);
        doc.setFont("helvetica", "", "normal");

        let columns1 = [
          { title: "DOCUMENTO", dataKey: "documento" },
          { title: "ENTREGADO", dataKey: "entregado" },
          { title: "PENDIENTE ", dataKey: "pendiente" }
        ];
        let rows1 = [];
        form.formularios_secciones_campos.forEach((column, b) => {
          column.forEach((campo, c) => {
            if (campo.imprimir_en_comprobante) {
              let info = this.dato.controls.personas_metadatos["controls"][campo.campo].value;
              rows1.push({
                documento: campo.descripcion.toUpperCase(),
                entregado: info == '1' ? "X" : "",
                pendiente: info == '0' ? "X" : ""
              });
            }
          });
        });
        conteo_lienas += 10;
        (doc as any).autoTable(columns1, rows1, {
          createdHeaderCell: function (cell, data) {
            cell.styles.halign = "left";
          },
          tableWidth: 187,
          startY: conteo_lienas,
          styles: {
            fontSize: 10
          },
          theme: "grid",
          columnStyles: {
            0: { cellWidth: 50 }
          }
        });
        conteo_lienas += rows1.length * 9;
      }


      conteo_lienas += 10;

      this.cargando = false;
      // doc.autoPrint();
      //const string = (doc as any).output("datauristring", "alumno.pdf");
      window.open((doc as any).output('bloburl'), '_blank');
      /*const iframe =
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>";

      const x = window.open();
      x.document.open();
      x.document.write(iframe);
      x.document.close();*/
    }, 100);
  }
}
